import { useState } from "react";
import styles from "./styles.module.css";
import Editor from "./editor";
import { MdCheckBox, MdCheckBoxOutlineBlank, MdRowing } from "react-icons/md";

export default function Rule({ rule, table, onChange, onDelete }) {
  const [name, setName] = useState(rule.name);

  const handleNameChange = () => {
    const _rule = { ...rule };
    _rule.name = name;
    onChange(_rule);
  };

  const handleEditorChange = (value) => {
    const _rule = { ...rule };
    _rule.condition = value;
    onChange(_rule);
  };

  const handleFieldsChange = (fields) => {
    const _rule = { ...rule };
    _rule.fields = fields;
    onChange(_rule);
  };

  const handleToggle = (key) => {
    const _rule = { ...rule };
    _rule[key] = !_rule[key];
    onChange(_rule);
  };
  return (
    <div className={styles.rule}>
      <div className={styles.propTitle}>Name</div>
      <input
        value={name}
        className={styles.nameInput}
        onChange={(e) => setName(e.target.value)}
        onBlur={handleNameChange}
      />
      <div style={{ marginTop: 15 }}>
        <div className={styles.propTitle}>Rule</div>
        <Editor
          onChange={handleEditorChange}
          value={rule.condition}
          table={table}
        />
      </div>
      <div style={{ marginTop: 15 }}>
        <div className={styles.propTitle}>Fields</div>
        <Fields
          onChange={handleFieldsChange}
          fields={rule.fields}
          table={table}
        />
      </div>
      <div style={{ marginTop: 15, display: "flex" }}>
        <div style={{ flexGrow: 1 }}>
          <div className={styles.propTitle}>Create Rows</div>
          {rule.create ? (
            <MdCheckBox
              onClick={() => handleToggle("create")}
              className={styles.checkBox + " " + styles.active}
            />
          ) : (
            <MdCheckBoxOutlineBlank
              onClick={() => handleToggle("create")}
              className={styles.checkBox}
            />
          )}
        </div>
        <div style={{ flexGrow: 1 }}>
          <div className={styles.propTitle}>Update Rows</div>
          {rule.update ? (
            <MdCheckBox
              onClick={() => handleToggle("update")}
              className={styles.checkBox + " " + styles.active}
            />
          ) : (
            <MdCheckBoxOutlineBlank
              onClick={() => handleToggle("update")}
              className={styles.checkBox}
            />
          )}
        </div>
        <div style={{ flexGrow: 1 }}>
          <div className={styles.propTitle}>Delete Rows</div>
          {rule.delete ? (
            <MdCheckBox
              onClick={() => handleToggle("delete")}
              className={styles.checkBox + " " + styles.active}
            />
          ) : (
            <MdCheckBoxOutlineBlank
              onClick={() => handleToggle("delete")}
              className={styles.checkBox}
            />
          )}
        </div>
      </div>
      <div style={{ marginTop: 15 }}>
        <div className={styles.propTitle}>Danger Zone</div>
        <button onClick={() => onDelete(rule)} className={styles.delete}>
          Delete Rule
        </button>
      </div>
    </div>
  );
}

const Fields = ({ fields, table, onChange }) => {
  const handleToggle = (key) => {
    const _fields = { ...fields };
    _fields[key] = !_fields[key];
    onChange(_fields);
  };
  return (
    <div className={styles.fields}>
      {Object.keys(table.fields).map((key) => {
        return (
          <div className={styles.field} key={key}>
            {fields[key] ? (
              <MdCheckBox
                onClick={() => handleToggle(key)}
                className={styles.checkBox + " " + styles.active}
              />
            ) : (
              <MdCheckBoxOutlineBlank
                onClick={() => handleToggle(key)}
                className={styles.checkBox}
              />
            )}
            {table.fields[key].name}
          </div>
        );
      })}
    </div>
  );
};
